export * from './cpf';
export * from './email';
export * from './phone-number';
export * from './uuid';
export * from './text';
